import { LeafletMouseEvent } from 'leaflet';

import { ClusterEventContext } from './clusterEvents';
import { MapRouteMarkerVM } from './mapVM';

/**
 * click ハンドラが受け取るもの。leaflet が直接呼ぶときはマウスイベント、
 * クラスター経由 (forwardClusterEvent) のときは文脈オブジェクトが渡る。
 */
type ClickArg = LeafletMouseEvent | ClusterEventContext | undefined;

const clusterContextOf = (arg: ClickArg): ClusterEventContext | undefined =>
  (arg != null && 'fromCluster' in arg ? arg : undefined);

type MarkerHandlers = {
  onMarkerRowClick?: (rowId: string) => void;
  onMarkerClick?: (rowId: string, marker: MapRouteMarkerVM) => void;
  /** 右クリックで選択解除。旧地図（/plans）と同じ操作 */
  onMarkerRowDeselect?: (rowId: string) => void;
};

// react-leaflet の Marker eventHandlers はコンポーネントテストが無いと配線漏れを
// 検知できない（brief 参照）。組み立て自体をここに切り出し、純粋関数として保証する。
export function buildRouteMarkerEventHandlers(
  rowId: string,
  marker: MapRouteMarkerVM,
  handlers: MarkerHandlers,
): { click: () => void; contextmenu: () => void } {
  return {
    click: () => {
      handlers.onMarkerRowClick?.(rowId);
      handlers.onMarkerClick?.(rowId, marker);
    },
    contextmenu: () => handlers.onMarkerRowDeselect?.(rowId),
  };
}

type UnassignedHandlers = {
  /** context はクラスター経由のときだけ渡る。集合状態なら詳細を出さない判断に使う */
  onUnassignedClick?: (id: string, context?: ClusterEventContext) => void;
  /** 右クリックで選択解除。旧地図（/plans）と同じ操作 */
  onUnassignedDeselect?: (id: string) => void;
};

export function buildUnassignedMarkerEventHandlers(
  id: string,
  handlers: UnassignedHandlers,
): { click: (arg?: ClickArg) => void; contextmenu: () => void } {
  return {
    click: (arg) => handlers.onUnassignedClick?.(id, clusterContextOf(arg)),
    contextmenu: () => handlers.onUnassignedDeselect?.(id),
  };
}
